import { GetDashboardDataResponse } from '@consigli/api-client';
import { ConflictCategory } from '@consigli/types';

export type ConflictTypesCount = GetDashboardDataResponse['conflictTypesCount'];

export interface FlatConflictItem {
  typeId: string;
  count: number;
  category: string;
}

export const CATEGORY_SORT_ORDER: Partial<Record<ConflictCategory, number>> = {
  [ConflictCategory.MISSING_DOCUMENTATION]: 1,
  [ConflictCategory.RISK]: 2,
  [ConflictCategory.INSIGHT]: 3,
  [ConflictCategory.RENTAL_AGREEMENT]: 4,
  [ConflictCategory.COMPANY]: 5,
  [ConflictCategory.PROPERTY]: 6,
};

// Each entry in typeEntries is a single-key object { [conflictType]: count }
// as defined by the API schema (conflict_types_count: Record<category, { [type]: number }[]>).
// Object.keys(entry)[0] relies on that single-key contract; we guard against
// malformed entries rather than silently producing undefined counts.
export function flattenCategories(
  entries: [string, ConflictTypesCount[string]][],
): FlatConflictItem[] {
  return entries.flatMap(([category, typeEntries]) =>
    typeEntries.flatMap((entry) => {
      const keys = Object.keys(entry);
      if (keys.length !== 1) return [];
      const typeId = keys[0];
      return [{ typeId, count: entry[typeId], category }];
    }),
  );
}

export function sumCounts(items: FlatConflictItem[]): number {
  return items.reduce((sum, item) => sum + item.count, 0);
}
